import React from "react";
import { Link } from "react-router-dom";

import "./Hero.css";

const Hero = () => {
  return (
    <section className="hero">

      {/* Background Video */}
      <video className="hero-video" autoPlay muted loop playsInline>
        <source src={`${process.env.PUBLIC_URL}/assets/images/icons/videos/inbuilt heros.mp4`} type="video/mp4" />
      </video>

      {/* Text & Buttons positioned exactly like the design */}
    <div className="hero-actions">
        <Link to="/contact" className="cta-btn">
          Get a Consultation
        </Link>
      </div>
    </section>
  );
};
export default Hero;
